import { render, staticRenderFns } from "./literacy.vue?vue&type=template&id=964e9a3a&"
import script from "./literacy.vue?vue&type=script&lang=js&"
export * from "./literacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports